import { memoryStorage } from "../../lib/memory-storage.js";

export const silenCalculator = () => {
    const $form = document.querySelector(".silen-calc__form");

    if (!$form) return;

    const $submitButton = $form.querySelector("button.site-btn");
    const handleSubmitForm = (e) => {
        e.preventDefault();
        e.stopPropagation();

        const formData = new FormData(e.target);

        const category = formData.getAll("category[]") ?? [];
        const codesVolume = formData.get("codesVolume");

        console.log(category, codesVolume);

        memoryStorage.set("silen-calc-data", {
            category: category.join(", "),
            codesVolume
        });
    };

    $submitButton.addEventListener("click", function() {
        $form.requestSubmit();
    });

    $form.addEventListener("submit", handleSubmitForm);

};